import queryString from 'query-string';
import { apiFetch } from './utils/api';

export const taxDetails = {
  get: async (args) => {
    const query = queryString.stringify(args, { arrayFormat: 'comma' });

    const options = {
      method: 'GET',
    };

    const url = `/v2/qlik/tax-details?${query}`;

    const { body } = await apiFetch(url, {
      ...options,
    });

    return body;
  },
};
